import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SalesInvoiceHeaderReferenceService extends BaseReferenceService {
  constructor() {
    super('SalesInvoiceHeaderReference');
  }
  getForCustomer(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForCustomer/${id}`);
  }
}
